import xs from "xstream"
import { div, label, button, select, hr } from "@cycle/dom"
import * as R from "ramda"

import {
  WorkForm,
} from "../../../../interface"
import {
  MODIFY_MSG,
} from "../../../../constant"

import {
  createTextArea,
  createTextInput,
  createCheckbox,
} from "../../../common"
import { createZipInputs, drawAddrSelect, prefOptions } from ".."

export const view = (
  userForm$: xs<WorkForm>,
  errorCheck$: xs<any>,
  zipMsg$: xs<string | null>,
  readOnly = false,
) =>
  xs
    .combine(userForm$, errorCheck$, zipMsg$)
    .map(
      ([userForm, errorCheck, zipMsg]: [
        WorkForm,
        any,
        string | null,
      ]) => {
        const disabled = R.find(
          (arr) => arr[1].check === false,
          R.toPairs(errorCheck),
        )
          ? true
          : false
        const gutter = readOnly ? "" : ".mt-2"
        return div([
          div(".form.mt-1", [
            readOnly ? null : div(".caution.mt-0.mb-2", [MODIFY_MSG]),
            div(`.row${gutter}`, [
              label(".form-label.fw-bold.mb-0", ["ご連絡先"]),
              drawAddrSelect(userForm, readOnly),
            ]),
            div(`.row${gutter}`, [
              label(".form-label", ["郵便番号"]),
              createZipInputs(userForm, errorCheck, zipMsg, readOnly),
            ]),
            div(`.row${gutter}`, [
              div(".col-md-2", [
                label(".form-label", ["都道府県"]),
                select(
                  ".form-select.form-select-sm",
                  { attrs: { name: "pref", disabled: readOnly } },
                  prefOptions(R.prop("pref", userForm)),
                ),
              ]),
            ]),
            div(`.row${gutter}`, [createTextInput("addr1", readOnly)(userForm, errorCheck)]),
            div(`.row${gutter}`, [createTextInput("addr2", readOnly)(userForm, errorCheck)]),
            div(`.row${gutter}.mt-1`, [
              createTextInput("tel", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [createTextInput("fax", readOnly)(userForm, errorCheck)]),
            div(`.row${gutter}`, [createTextInput("mobile", readOnly)(userForm, errorCheck)]),
            hr(),
            div(`.row${gutter}`, [createTextArea("bikou", readOnly)(userForm, errorCheck)]),
            div(".d-grid.gap-3.mt-4", [
              div(".col.col-md-4", [
                readOnly
                  ? button(
                    "#btnSend.btn.btn-danger.w-100",
                    { props: { disabled: disabled } },
                    ["変更申請を行う"],
                  )
                  : button(
                    "#btnConfirm.btn.btn-primary.w-100",
                    { props: { disabled: disabled } },
                    ["申請内容を確認する"],
                  ),
              ]),
              div(".col.col-md-4", [
                button( "#btnReturn.btn.btn-success.w-100", ["戻る"]),
              ]),
            ]),
          ]),
        ])
      },
    )
